import React from 'react'
import { Container, Icon } from 'gu-ui-kit'
import styles from 'components/FileUploader/subcomponents/StatusIcon/status-icon.module.scss'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const StatusIcon = ({ status }) => {
  const breakpoints = useBreakpoint()
  return (
    <Container
      display={'flex'}
      className={clsx(styles['container'], {
        [styles['container_' + status]]: status,
        [styles['container_small']]: breakpoints.sm,
      })}
    >
      <Icon
        name={'document'}
        size={breakpoints.sm ? 's' : 'm'}
        className={clsx(styles['icon'], {
          [styles['icon_' + status]]: status,
        })}
      />
    </Container>
  )
}

StatusIcon.propTypes = {
  status: PropTypes.oneOf(['loaded', 'error']),
}

export default StatusIcon
